// extracted by mini-css-extract-plugin
export default {"countdown":"A64Uadvr","icon":"mvZrP11x","text":"NWa22OXS","value":"aWLM7WNz"};